import { useEffect } from "react";

const fetchIndex = () =>
  fetch(`/index.html?_v=${Date.now()}`, { cache: "no-store" }).then((r) => (r.ok ? r.text() : null)).catch(() => null);

// Detects a newly deployed frontend build and reloads so phones never keep an old version.
export default function useAutoUpdate(intervalMs = 60000) {
  useEffect(() => {
    let initial = null;
    fetchIndex().then((html) => { initial = html; });
    const check = async () => {
      if (!initial || document.visibilityState !== "visible") return;
      const latest = await fetchIndex();
      if (latest && latest !== initial) window.location.reload();
    };
    const id = setInterval(check, intervalMs);
    document.addEventListener("visibilitychange", check);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", check);
    };
  }, [intervalMs]);
}
